import { MapTo } from '@adobe/cq-react-editable-components';

// import { isFuncComp } from '../../../../components/common/Helpers';
import Loadable from '../../../../utils/loadable';

// const shippingSubHeader = Loadable(() =>
//   !isFuncComp() ? import('../../containers/web/shippingSubHeader') : import('../../FuncComponnetContainers/web/shippingSubHeader'),
// );

const shippingSubHeader = Loadable(() => import('../../containers/shippingSubHeader'));

export default MapTo('vcg/components/soe-home/react/shippingSubHeading')(shippingSubHeader);
